import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-expiration-item',
  templateUrl: './expiration-item.component.html',
  styleUrls: ['./_expiration-item.component.scss'],
})
export class ExpirationItemComponent implements OnInit {
  @Input() expirations_input: any;
  @Input() ship = 0;
  @Input() expiration_type_input: any;
  @Output() dataProcessed: EventEmitter<any> = new EventEmitter<any>();
  @Output() deleteExpirationInfo: EventEmitter<any> = new EventEmitter<any>();
  expiration: any;
  expirations: any;
  expiration_type = '';
  expirations_child_data: any = [];
  existingData: any = [];
  processingData = false;
  limitDays = 30;

  constructor() {}

  ngOnInit(): void {
    this.expirations = this.expirations_input.expirations;
    this.expiration = this.expiration_type_input.filter((item: any) => {
      return item.name === this.expirations_input.name;
    })[0];
    this.limitDays = this.expiration.reminder === null ? 30 : parseInt(this.expiration.reminder.split(',')[0], 10);
    if (this.expirations.length === 0) {
      this.addExpiration();
    }
    this.expiration_type = this.expirations[0].expiration.expiration_type;
  }

  procesarDatos(data: any) {
    if (data.length <= 0) {
      return;
    }
    data = {
      ...data,
      ship: this.expirations[0].ship,
      expiration_id: this.expirations[0].expiration.id,
    };

    this.expirations_child_data = this.expirations_child_data === null ? [] : this.expirations_child_data;
    const existingIndex = this.expirations_child_data.findIndex((item: any) => item.id === data.id);

    if (existingIndex === -1) {
      this.expirations_child_data.push(data);
    } else {
      const existingItem = this.expirations_child_data[existingIndex];
      if (existingItem.date !== data.date || existingItem.text !== data.text || existingItem.zafa_expiration_date !== data.zafa_expiration_date) {
        this.expirations_child_data[existingIndex].date = data.date;
        this.expirations_child_data[existingIndex].text = data.text;
        this.expirations_child_data[existingIndex].zafa_expiration_date = data.zafa_expiration_date;
      }
    }
    this.dataProcessed.emit(this.expirations_child_data);
  }

  addExpiration() {
    this.expirations.push({
      id: undefined,
      certificate_type: null,
      identifier_name: '',
      serial_number: '',
      expiration_date: null,
      expiration: this.expiration,
      license_modality: '',
      person_name: '',
      radiobaliza_type: null,
      ship: this.ship,
      zafa_expiration_date: null,
    });
  }

  deleteExpiration(expiration_index: any) {
    const expiration = this.expirations[expiration_index];
    this.expirations.splice(expiration_index, 1);
    if (!expiration.id) {
      return;
    }
    this.deleteExpirationInfo.emit(expiration.id);
  }
}



// WEBPACK FOOTER //
// ./src/app/expirations/expiration-item/expiration-item.component.ts